import React, { useEffect, useState } from 'react';

const BlogList = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    const loadPosts = async () => {
      const res = await fetch(`${process.env.PUBLIC_URL}/posts.json`);
      const postsData = await res.json();
      setPosts(postsData);
    };
    loadPosts();
  }, []);

  return (
    <div>
      <h2>Blog Posts</h2>
      <ul>
        {posts.map((post) => (
          <li key={post.slug}>
            <a href={`#/blog/${post.slug}`}>{post.title}</a> — {post.date}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default BlogList;
